import { render } from "./DashboardAdministradoresComponent.vue?vue&type=template&id=57ef294b&scoped=true"
import script from "./DashboardAdministradoresComponent.vue?vue&type=script&lang=js"
export * from "./DashboardAdministradoresComponent.vue?vue&type=script&lang=js"

import "./DashboardAdministradoresComponent.vue?vue&type=style&index=0&id=57ef294b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ef294b"]])

export default __exports__